import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { LqsPage } from "~/lqs/layout";
import { RoleDetails } from "./components/RoleDetails";

export function RolePage() {
  return (
    <LqsPage title="Role Details">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <RoleDetails />
      </Container>
    </LqsPage>
  );
}
